/* eslint-disable eqeqeq */
/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable no-unused-vars */
import React, { useEffect, useRef, useState } from "react";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import "primereact/resources/themes/saga-blue/theme.css"; // Theme
import "primereact/resources/primereact.min.css";
import Button from "@mui/material/Button";
import DownloadIcon from "@mui/icons-material/Download";
import * as XLSX from "xlsx"; // Importing xlsx library
import TelegramWidget from "../../components/widget/telegramWidget";
import SessionLogout from "../../components/animation/sessionLogout";
import { BASE_URL } from "../../utils/config";
import { Modal, Alert } from "react-bootstrap";
import { useNavigate } from "react-router-dom";


const SubscriberData = () => {
  const [sessionExpired, setSessionExpired] = useState(false);
  const [showExample, setShowExample] = useState(true);
  const [excelData, setExcelData] = useState([]);
  const [exampleColumns, setExampleColumns] = useState([]);
  const [subscriberColumns, setSubscriberColumns] = useState([]);
  const [fileData, setFileData] = useState([]);
  const fileInputRef = useRef(null); // Ref for file input

  const [showSuccessMessage, setShowSuccessMessage] = useState(false);
  const [showErrorMessage, setShowErrorMessage] = useState(false);
  const [Errormessage, setErrormessage] = useState("");
  
  const navigate = useNavigate();


  // Convert Excel date serial to readable format
  const convertExcelDate = (serial) => {
    if (!serial) return ""; // Handle empty values

    const excelEpoch = new Date(Date.UTC(1900, 0, 1)); // Excel's base date (January 1, 1900) in UTC
    const daysOffset = serial - 2; // Subtract 2 instead of 1 to adjust for the leap year bug (Excel incorrectly considers 1900 a leap year)

    const date = new Date(
      excelEpoch.getTime() + daysOffset * 24 * 60 * 60 * 1000
    );

    // Use UTC methods to prevent time zone offsets
    const day = String(date.getUTCDate()).padStart(2, "0");
    const month = String(date.getUTCMonth() + 1).padStart(2, "0"); // Months are 0-based
    const year = date.getUTCFullYear();
    const hours = String(date.getUTCHours()).padStart(2, "0");
    const minutes = String(date.getUTCMinutes()).padStart(2, "0");
    const seconds = String(date.getUTCSeconds()).padStart(2, "0");

    return `${day}-${month}-${year} ${hours}:${minutes}:${seconds}`;
  };

  useEffect(() => {
    // Fetch and display example Excel data
    const fetchExcelFile = async () => {
      const response = await fetch("/subscriber.xlsx");
      const arrayBuffer = await response.arrayBuffer();
      const workbook = XLSX.read(arrayBuffer, { type: "array" });
      const sheetName = workbook.SheetNames[0];
      const worksheet = workbook.Sheets[sheetName];
      const data = XLSX.utils.sheet_to_json(worksheet);

      const formattedData = data.map((row) => ({
        ...row,
        purchase_date: convertExcelDate(row.purchase_date),
        starting_date: convertExcelDate(row.starting_date),
        ending_date: convertExcelDate(row.ending_date)
      }));

      setFileData(formattedData);

      if (data.length > 0) {
        const cols = Object.keys(data[0]).map((key) => ({
          field: key,
          header: key
        }));

        setExampleColumns(cols);
      }
    };

    fetchExcelFile();
  }, []);

  const handleFileChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      const reader = new FileReader();
      reader.onload = (event) => {
        const binaryString = event.target.result;
        const workbook = XLSX.read(binaryString, { type: "binary" });
        const sheetName = workbook.SheetNames[0];
        const worksheet = workbook.Sheets[sheetName];
        const data = XLSX.utils.sheet_to_json(worksheet);

        const formattedData = data.map((row) => ({
          ...row,
          purchase_date: convertExcelDate(row.purchase_date),
          starting_date: convertExcelDate(row.starting_date),
          ending_date: convertExcelDate(row.ending_date)
        }));
        console.log(formattedData);

        if (data.length > 0) {

     // want to check fileData array and excelData array that they have same column in same position or not

     const fileColumns = Object.keys(fileData[0]);
     const datakey = Object.keys(data[0]);

     // Check if lengths match
     if (fileColumns.length !== datakey.length) {
       console.log("Column counts do not match.");
       setErrormessage("Column counts do not match.");
       setShowErrorMessage(true);
       setTimeout(() => {
         setShowErrorMessage(false);
         setErrormessage("");
       }, 2000);
         // Reset file input to allow selecting the same file again
      e.target.value = null;
       return;
     }

     // Check if column names match in order
     for (let i = 0; i < fileColumns.length; i++) {
       console.log(
         "typeof file",
         typeof fileColumns[0],
         typeof datakey[0]
       );
       if (fileColumns[i] !== datakey[i]) {
         console.log(
           `Mismatch at column ${i + 1}: ${fileColumns[i]} !== ${
             datakey[i]
           }`
         );
         setErrormessage(
           `Mismatch at column ${i + 1}: ${fileColumns[i]} !== ${
             datakey[i]
           }`
         );
         setShowErrorMessage(true);
         setTimeout(() => {
           setShowErrorMessage(false);
           setErrormessage("");
         }, 2000);

           // Reset file input to allow selecting the same file again
      e.target.value = null;
      return
        
       }
     }
          const cols = Object.keys(data[0]).map((key) => ({
            field: key,
            header: key
          }));
  
          setSubscriberColumns(cols);
          setExcelData(formattedData);
          setShowExample(false);
        }
          // Reset file input to allow selecting the same file again
      e.target.value = null;
      };
      reader.readAsBinaryString(file);
    }
  };

  const handleImportClick = () => {
    // Trigger file input click
    fileInputRef.current.click();
  };

  const submitData = async () => {
    try {
      if (excelData.length === 0) {
        setErrormessage("Please Select Excel File.");
        setShowErrorMessage(true);
        setTimeout(() => {
          setShowErrorMessage(false);
          setErrormessage("");
        }, 2000);
        return;
      }

    

      const details = JSON.parse(localStorage.getItem("userData"));
      const created_by = details.user_id;
      const token = localStorage.getItem("AUTH");

      const subscribers = excelData;
      const response = await fetch(`${BASE_URL}/subscriber-data`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`
        },
        body: JSON.stringify({ subscribers, created_by })
      });

      if (response.ok) {
        // alert("Data submitted successfully!");
        setErrormessage("Data submitted successfully!");
        setShowSuccessMessage(true);
        setTimeout(() => {
          
          setExcelData([])
          
          setShowSuccessMessage(false);
          setShowExample(true)
          setErrormessage("");
        }, 2000);
      } else {
        // alert("Failed to submit data.");
        setErrormessage("Failed to submit data.");
        setShowErrorMessage(true);
        setTimeout(() => {
          setShowErrorMessage(false);
          setErrormessage("");
        }, 2000);
      }
    } catch (error) {
      console.error("Error submitting data:", error);
      // alert("An error occurred while submitting data.");
      setErrormessage("Internal Server Error.");
        setShowErrorMessage(true);
        setTimeout(() => {
          setShowErrorMessage(false);
          setErrormessage("");
        }, 2000);
    }
  };

  const leftToolbarTemplate = () => {

    return (
      <div
        style={{
          display: "flex",
          justifyContent: "end",
          alignItems: "center",
          marginBottom: "30px"
        }}
      >
        <Button
          variant="contained"
          endIcon={<DownloadIcon />}
          onClick={handleImportClick}
          style={{ marginRight: "10px" }}
        >
          Import Excel
        </Button>
        <Button
          disabled={excelData.length === 0}
          variant="contained"
          endIcon={<DownloadIcon />}
          onClick={submitData}
          style={{ marginRight: "10px" }}
        >
          Submit Excel
        </Button>
      </div>
    );
  };

  return (
    <div>
      <div className="user-list">
        <div
        style={{
            display: "flex",
            alignItems: "center",
            padding: "24px 30px 0 30px"
        }}
        >
        <Button
            variant="text"
            onClick={() => navigate(-1)}
            style={{
            textTransform: "none",
            fontWeight: 600
            }}
        >
            ← Back
        </Button>
        </div>

        <div style={{ padding: "20px" }}>
          {/* Hidden File Input */}
          <input
            ref={fileInputRef}
            type="file"
            accept=".xlsx,.xls"
            style={{ display: "none" }}
            onChange={handleFileChange}
          />
        </div>

        <div className="exampleSubscriberDataTable">
          {leftToolbarTemplate()}
          {showExample ? (
            <>
              <div className="userlist_Heading">Example Excel Data</div>
              {fileData.length > 0 && (
                <DataTable value={fileData} responsiveLayout="scroll">
                  {exampleColumns.map((col, index) => (
                    <Column key={index} field={col.field} header={col.header} />
                  ))}
                </DataTable>
              )}
            </>
          ) : null}

          {excelData.length > 0 && (
            <>
              <div className="userlist_Heading">Subscriber Excel Data</div>
              <DataTable
                value={excelData}
                paginator
                rows={10}
                rowsPerPageOptions={[10, 20, 30, 50]}
                responsiveLayout="scroll"
              >
                {subscriberColumns.map((col, index) => (
                  <Column key={index} field={col.field} header={col.header} />
                ))}
              </DataTable>
            </>
          )}
        </div>
      </div>

      {/* success message  */}
      <Modal
        show={showSuccessMessage}
        onHide={() => setShowSuccessMessage(false)}
        style={{ padding: 0, zIndex: 9999 }}
      >
        {" "}
        <Alert variant="success">{Errormessage}</Alert>
      </Modal>

      {/* Failed pop up  */}
      <Modal
        show={showErrorMessage}
        onHide={() => setShowErrorMessage(false)}
        style={{ padding: 0 }}
      >
        {" "}
        <Alert variant="danger">{Errormessage}"</Alert>
      </Modal>

      <TelegramWidget />
      
      {sessionExpired ? <SessionLogout /> : null}
    </div>
  );
};

export default SubscriberData;
